import { useCallback, useTransition } from 'react'

import { useNavigate } from '@tanstack/react-router'

import type { LinkOptions } from '@tanstack/react-router'

export type UpdateURLOptions = {
	to?: LinkOptions['to']
	search: LinkOptions['search']
	/**
	 * Overwrite the current history entry instead of adding one. Use it for
	 * writes the app makes on its own (filling defaults, syncing a draft), so
	 * Back steps through what the user did, not through automatic URL writes.
	 */
	replace?: boolean
}

/**
 * Merges `search` into the current URL inside a transition, so the write does
 * not block UI updates. Pushes a history entry unless `replace` is set.
 */
export const useUpdateURL = () => {
	const navigate = useNavigate()

	const [_isPending, startTransition] = useTransition()

	const updateURL = useCallback(
		({ to = '.', search, replace }: UpdateURLOptions) => {
			startTransition(() => {
				navigate({
					to,
					replace,
					// Merge the new state with the existing URL search params
					search: (prev) => ({
						...prev,
						...(search as unknown as Record<string, unknown>),
					}),
				})
			})
		},
		[navigate],
	)

	return { updateURL }
}
